"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderMenuSavedOffers = HeaderMenuSavedOffers;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_1 = require("@ant-design/icons");
const elements_1 = require("@src/components/elements");
const saved_offer_context_1 = require("@src/context/saved-offer-context");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
function HeaderMenuSavedOffers() {
    var _a;
    const { savedOffers } = (0, saved_offer_context_1.useSavedOffersContextValue)();
    return ((0, jsx_runtime_1.jsx)(SavedOfferLink, { to: "/ucet/ulozene-ponuky", children: (0, jsx_runtime_1.jsx)(elements_1.Badge, { size: "small", count: (_a = savedOffers.length) !== null && _a !== void 0 ? _a : undefined, children: (0, jsx_runtime_1.jsx)(icons_1.HeartFilled, {}) }) }));
}
const SavedOfferLink = (0, styled_components_1.default)(elements_1.Link) `
	height: 2.5rem;
	display: flex;
	align-items: center;
	width: 2.5rem;
	justify-content: center;

	svg {
		width: 18px;
		height: 18px;
		color: ${({ theme }) => theme.color.white};
		opacity: 0.4;
		transition: all ${({ theme }) => theme.transition.basic};
	}

	.ant-badge-count {
		top: 0px;
		right: -4px;
	}

	&:hover svg {
		opacity: 1;
		transform: scale(1.1);
	}
`;
